import { Typography, Modal, Checkbox, Row, Col, Divider } from 'antd';
import { useState, useEffect, useRef, useMemo } from 'react';
import {useLocalStorageListener,getUserDetail, updateUserDetail } from '../../../hooks/handleUserLocalStorage';
import { useLoading } from '../../../context/LoadingContext';

import moment from 'moment';
import { useGlobalVariable } from '../../../context/GlobalVariableProvider';
import ChangePasswordForm from '../../forms/change-password';
const { Title } = Typography;
interface Property {
    opened: boolean;
    children?: any;
    onClosed?: any;
    display?: any;
}

const ForceUpdatePasswordModal = (props: Property) => {
    // const [cookies, setCookie,removeCookie] = useCookies(['user']);
 
    const [title, setTitle] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isTradingPinModalOpen, setIsTradingPinModalOpen] = useState(false);
    const pendingTradingPin = useRef(false);

     const { setLoading } = useLoading();

    const { setShowingForceChangePassword } = useGlobalVariable();

    useLocalStorageListener((_localdata: any) => {
        let localUser = getUserDetail();
        if (localUser?.user) {
            const needPassword = !!localUser?.reset_password_mode;
            const needTradingPin = !!localUser?.reset_trading_pin_mode;
            if (needPassword) {
                pendingTradingPin.current = needTradingPin;
                setIsModalOpen(true);
            } else if (needTradingPin) {
                setIsTradingPinModalOpen(true);
            }

        }
    });

    useEffect(() => {
        setShowingForceChangePassword(isModalOpen);
        if (isModalOpen == true) {
          setLoading(false)
        }
    }, [isModalOpen]);

    const clearResetPasswordMode = () => {
        let localUser = getUserDetail();
        localUser.reset_password_mode = 0;
        updateUserDetail(localUser);
    };

    const handlePasswordSuccess = () => {
        setLoading(false);
        setIsModalOpen(false);
      
        if (pendingTradingPin.current) {
        
            clearResetPasswordMode();

            pendingTradingPin.current = false;
            setIsTradingPinModalOpen(true);
        }
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };



    return (
        <>
            <Modal
                // bodyStyle={{
                //     overflowY: 'auto',
                //     minHeight: '70vh',
                //     maxHeight: '70vh',
                //     min
                //     maxWidth: '800px',
                //     // minWidth: '80vw'
                // }}
                title={title}
                open={isModalOpen}
                onCancel={handleCancel}
                closable={false}
                okButtonProps={{ style: { display: 'none' } }}
                maskClosable={false}
                footer={null}
            >
                <div style={{ position: 'relative', height: '100%',width:'100%',maxWidth:'800px' }}>
                    <Title level={3}>Change Password</Title>
                    <Divider />
                    <ChangePasswordForm isForceChangePassword={true} onSuccess={handlePasswordSuccess} skipLogout={pendingTradingPin.current} />
            
                </div>
            </Modal>

            <Modal
                title={null}
                open={isTradingPinModalOpen}
                closable={false}
                maskClosable={false}
                footer={null}
            >
                <div style={{ position: 'relative', height: '100%', width: '100%', maxWidth: '800px' }}>
                    <Title level={3}>Change Trading PIN</Title>
                    <Divider />
                    <ChangePasswordForm type="trading_pin" isForceChangePassword={true} />
                </div>
            </Modal>

        </>
    );
};

export default ForceUpdatePasswordModal;
